<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import {
  assignmentComputed,
  assignmentListMethod,
  authComputed,
  collegeComputed,
  collegeListMethod,
  siteListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Assignment List',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Table,
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      assignmentlist: {},
      allAssignmentList: {},
      collegelist: [],
      collegeId: 'All',
      platformId: 'All',
      isUserAdmin: false,
      siteconfiglist: [],
      fields: [
        {
          value: 'title',
          text: 'Title',
          sortable: true,
          colType: 'default',
          width: '30%',
        },
        {
          value: 'document',
          text: 'Document(s)',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'deadline',
          text: 'Submission Deadline',
          colType: 'date',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        {
          key: 'title',
          label: 'Title',
          colType: 'default',
        },
        {
          key: 'description',
          label: 'Description',
          colType: 'default',
        },
        {
          key: 'document',
          label: 'Document(s)',
          colType: 'default',
        },
        {
          key: 'assigned_by',
          label: 'Added By',
          colType: 'default',
        },
        {
          key: 'deadline',
          label: 'Submission Deadline',
          colType: 'date',
        },
      ],
    }
  },
  computed: {
    ...assignmentComputed,
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getListOfPlatform()
    this.getListOfAssignments()
    this.getColleges()
  },
  methods: {
    ...assignmentListMethod,
    ...collegeListMethod,
    ...siteListMethod,
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
          this.allCollegeList = listitems
        })
        .catch((_error) => {})
    },

    getAssignments() {
      if (this.collegeId !== 'All') {
        let listitems = []
        this.allAssignmentList.docs.forEach((element) => {
          if (element.college_id === this.collegeId) {
            listitems.push(element)
          }
        })
        this.assignmentlist.docs = listitems
      } else {
        if (this.role !== 'admin') {
          this.assignmentlist.docs = this.allAssignmentList.docs
        } else {
          let listitems = []
          this.allAssignmentList.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              listitems.push(element)
            }
          })
          this.assignmentlist.docs = listitems
        }
      }
    },

    getPlatformColleges() {
      this.collegeId = 'All'
      this.isUserAdmin = true
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCollegeList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.collegelist = listitems
      if (this.platformId !== 'All') {
        let listitems = []
        this.allAssignmentList.docs.forEach((element) => {
          if (element.platform_id === Number(this.platformId)) {
            listitems.push(element)
          }
        })
        this.assignmentlist.docs = listitems
      } else {
        this.assignmentlist.docs = this.allAssignmentList.docs
      }
    },

    // Get list of all assignments role wise
    getListOfAssignments() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchAssignmentList({
        filter,
      })
        .then((assignmentList) => {
          this.assignmentlist = JSON.parse(JSON.stringify(assignmentList))
          this.allAssignmentList = JSON.parse(JSON.stringify(assignmentList))
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <router-link
              v-if="role !== 'administrator' && role !== 'admin'"
              tag="button"
              to="/assignment-add"
              class="btn btn-info mb-2"
            >
              <i class="ti-plus"></i><span> Add Assignment</span> </router-link
            ><br />
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getPlatformColleges"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              v-if="
                (role === 'admin' && isUserAdmin) || role === 'administrator'
              "
              label="Select College"
              label-for="input-1"
            >
              <b-form-select
                v-model="collegeId"
                :options="collegelist"
                style="width: 50%"
                @change="getAssignments"
              ></b-form-select>
            </b-form-group>
            <Table
              :items="assignmentlist.docs ? assignmentlist.docs : []"
              :fields="fields"
              :bordered="true"
              :viewbtn="true"
              :deletebtn="true"
              :editbtn="true"
              :assignment="true"
            ></Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
